import React from 'react';
import {view} from '@sail/ui';

import {message, useIntl} from '@sail/intl';

const messages = {
  errorHeading: message({
    id: 'connectEmbedLib.embeddedSupport.errorHeading',
    defaultMessage: 'Something went wrong.',
    description: 'Error message when creating support email.',
  }),

  errorBody: message({
    id: 'connectEmbedLib.embeddedSupport.errorBody',

    defaultMessage:
      'We were unable to create your support request. Please try again.',

    description: 'Error message body',
  }),
};

export const EmbeddedSupportError = () => {
  const intl = useIntl();
  return (
    <view.div
      css={{
        padding: 'large',
        stack: 'y',
        textAlign: 'center',
        alignX: 'center',
        alignY: 'center',
      }}
    >
      <view.h3
        css={{
          marginY: 'space.0',
          font: 'heading.medium',
          color: 'text',
          fontWeight: 'regular',
          marginBottom: 'medium',
        }}
      >
        {intl.formatMessage(messages.errorHeading)}
      </view.h3>
      <view.span
        css={{
          font: 'body.small',
          color: 'subdued',
          marginBottom: 'large',
        }}
      >
        {intl.formatMessage(messages.errorBody)}
      </view.span>
    </view.div>
  );
};
